export default "__VITE_ASSET__BpJx1RiP__"